
export const environment = {
  production: false,
  baseUrl: 'https://telecheckup-dev.uc.r.appspot.com/',
  intakeFormBaseUrl: 'https://pathway-video.s3.ap-south-1.amazonaws.com/pdf/',
  appUrl: '/'
};
